
export default {
  name: 'AppLoader',
  data: (vm) => ({
    loading: false
  }),

  methods: {
    start() {
      this.loading = true
    },
    finish() {
      setTimeout(() => {
        this.loading = false
      }, 2500)
    }
  }
}
